import React from 'react';
import PropTypes from 'prop-types';

const EcapCheckMark = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>ECAP Checkmark</title>
      <g id="Group_9065" transform="translate(-537 -366)">
        <g id="Group_9064" transform="translate(537 366)">
          <g id="Group_9063">
            <g id="Group_9062">
              <path
                fill={color}
                id="Path_13843"
                className="st0"
                d="M499.9,999.7c-276.1,0-500-223.9-500-500s223.9-500,500-500s500,223.9,500,500
               S776,999.7,499.9,999.7z M499.9,916.4c230.1,0,416.7-186.6,416.7-416.7S730,83,499.9,83S83.2,269.6,83.2,499.7
               C83.2,729.8,269.7,916.4,499.9,916.4L499.9,916.4z M432.3,584.6l265.1-265.1c16.3-16.3,42.8-16.3,59.1,0
               c16.3,16.3,16.3,42.8,0,59.1L462,673.1l0,0c-16.2,16.3-42.5,16.4-58.8,0.3c-0.1-0.1-0.2-0.2-0.3-0.3l0,0L285.1,555.2
               c-16.3-16.3-16.3-42.8,0-59.1c16.3-16.3,42.8-16.3,59.1,0l0,0L432.3,584.6z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EcapCheckMark;

EcapCheckMark.propTypes = {
  color: PropTypes.string.isRequired,
};
